<template>
  <div class="dashboard__view settings-view">
    <div class="list content-window">
      <div class="tab settings-tab">
        <div>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/profile"
            :class="state.subTabName === '' ? 'active' : ''"
            @click.native="() => (state.subTabName = '')"
            exact
          >
            Profile
          </router-link>
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/business">Business Info</router-link> -->
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/bankaccount">Bank Account</router-link> -->
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/apikeys">API Keys</router-link> -->
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/preference">Preference</router-link> -->
          <div
            class="nav-customise"
            :class="state.subTabName === 'configuration' ? 'active' : ''"
            @click="() => handleTabChange('/dashboard/settings/fee')"
            exact
          >
            Configuration
          </div>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/password"
            @click.native="() => (state.subTabName = 'password')"
            :class="state.subTabName === 'password' ? 'active' : ''"
          >
            Change Password
          </router-link>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/directdebit"
            @click.native="() => (state.subTabName = 'directdebit')"
            :class="state.subTabName === 'directdebit' ? 'active' : ''"
            >Direct Debit</router-link>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/bills-payment"
            @click.native="() => (state.subTabName = 'billspayment')"
            :class="state.subTabName === 'billspayment' ? 'active' : ''"
            >Bills Payment</router-link>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/authentication"
            @click.native="() => (state.subTabName = 'authentication')"
            :class="state.subTabName === 'authentication' ? 'active' : ''"
            >Authentication</router-link>
        </div>
        <div v-if="state.subTabName === 'configuration'" class="sub-nav">
          <div class="flex">
            <router-link
              class="tab__item--nav margin-left"
              tag="div"
              to="/dashboard/settings/fee"
              exact
              >Bank Fee</router-link
            >
            <router-link
              class="tab__item--nav margin-left"
              tag="div"
              to="/dashboard/settings/routingrules/default"
              exact
              >vNUBAN</router-link
            >
            <router-link
                class="tab__item--nav margin-left"
                tag="div"
                to="/dashboard/settings/routingrules"
                exact
            >Routing Rules</router-link
            >
            <router-link
                class="tab__item--nav margin-left"
                tag="div"
                to="/dashboard/settings/priority-config"
                exact
            >Priority</router-link
            >
          </div>

          <Button
            buttonName="Add Bank Fee"
            :onClick="handleRedirectCreateFee"
            classes="primary add-fee"
            v-if="$route.name === 'settings-fee'"
          >
            <template>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 1V11"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 6H11"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </Button>
        </div>
      </div>

      <div class="tab__content">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch } from "@vue/composition-api";
import Button from "@/components/button.vue";
export default {
  components: { Button },
  setup(props, { root }) {
    const state = reactive({
      subTabName: "",
    });
    const isConfigurationPath = (path) =>
      path.startsWith("/dashboard/settings/fee") ||
      path.startsWith("/dashboard/settings/routingrules") ||
      path === "/dashboard/settings/priority-config";

    const syncSubTab = (path) => {
      if (isConfigurationPath(path)) {
        state.subTabName = "configuration";
        return;
      }
      if (path === "/dashboard/settings/password") {
        state.subTabName = "password";
        return;
      }
      if (
        path === "/dashboard/settings/directdebit" ||
        path.startsWith("/dashboard/settings/directdebit/")
      ) {
        state.subTabName = "directdebit";
        return;
      }
      if (path === "/dashboard/settings/bills-payment") {
        state.subTabName = "billspayment";
        return;
      }
      if (path === "/dashboard/settings/authentication") {
        state.subTabName = "authentication";
        return;
      }
      if (path === "/dashboard/settings/profile") {
        state.subTabName = "";
      }
    };

    watch(() => root.$route.path, syncSubTab, { immediate: true });

    const handleTabChange = (path) => {
      state.subTabName = "configuration";
      if (!isConfigurationPath(root.$route.path)) {
        root.$router.push(path);
      }
    };
    const handleRedirectCreateFee = () =>
      root.$router.push({ name: "settings-fee-add" });
    return {
      state,
      handleTabChange,
      handleRedirectCreateFee,
    };
  },
};
</script>

<style lang="scss">
.settings-view {
  .flex {
    display: flex;
    justify-content: center;
  }
  .add-fee {
    position: absolute;
    right: 30px;
    width: 160px;
    height: 52px;
    top: 0;

    svg {
      margin-right: 10px;
    }
  }
  .sub-nav {
    display: flex;
    margin: 0px auto;
    justify-content: center;
    width: calc(100%);
    position: relative;
  }
  .settings-tab {
    display: flex;
    flex-direction: column;
    padding-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border: none !important;
    > div {
      display: flex;
      padding-top: 32px;
      padding-left: 40px;
      border: none !important;
      padding-right: 32px;
    }
    > div:first-child {
      border-bottom: 1px solid #ebf0f4;
    }
    .nav-customise {
      cursor: pointer;
      margin-right: 24px;
      color: rgba(50, 63, 75, 0.5);
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
    .active {
      border-bottom: 1px solid #261940;
      // text-decoration: underline;
      color: #261940;
    }
  }
  .profile {
    border-top: none !important;
    padding: 48px 40px;
  }
  .underline {
    text-decoration: underline;
  }
  .margin-left {
    margin-right: 24px;
  }
  .content-window {
    width: fit-content;
    border: none !important;
    min-width: 100%;
  }
  .tab__item--nav {
    margin-right: 24px;
    padding: 0;
    color: rgba(50, 63, 75, 0.5);
    cursor: pointer;
  }
  .router-link-exact-active {
    color: #000;
  }
  .tab__content {
    margin-top: 55px;
  }
}
</style>
